import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const MoreInsights = styled.div`
  background-color: var(--surface-default);
  border-radius: 4px;
  padding: 2px 6px;
  height: fit-content;
  margin-left: 8px;
`;

export const Count = styled.span`
  color: var(--text-soft);
  ${typographyV2.bodyXs};
  vertical-align: middle;
  display: block;
`;
